<template>
  <div class="modal-wrapper" :class="`modal-wrapper--${display}`">
    <slot name="trigger"/>

    <b-modal v-model="modalShow"
             :size="modalSize"
             :modal-class="`${modalClass} browser-${currentBrowser}`"
             centered
             hide-header
             hide-footer
             :no-close-on-backdrop="noCloseOnBackdrop">
      <padding size="large">
        <div class="flex__column">
          <div class="flex__row">
            <div class="flex__column flex--100">
              <slot name="title"/>
            </div>
            <div class="flex__column">
              <close-button size="small" @click="closeModal"/>
            </div>
          </div>
          <slot name="content" :closeModal="closeModal"/>
        </div>
      </padding>
    </b-modal>
  </div>
</template>

<script>
import Padding from './Utils/Padding'
import CloseButton from './Buttons/CloseButton'
import { currentBrowser } from '../utils/browser'

export default {
  name: 'Modal',
  components: { CloseButton, Padding },
  props: {
    modalSize: {
      type: String,
      default: 'md',
    },
    showCloseButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    display: {
      type: String,
      required: false,
      default: 'block',
      validate: ['block', 'inline', 'flex'].includes,
    },
    modalClass: {
      type: String,
      required: false,
      default: '',
    },
    noCloseOnBackdrop: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      modalShow: false,
      currentBrowser,
    }
  },
  methods: {
    openModal() {
      this.modalShow = true
    },
    closeModal() {
      this.modalShow = false
      this.$emit('close')
    },
  },
}
</script>
